import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import PageHelmet from '@bd/bdcore-pagehelmet';
import { css } from '@bd/bdui-styles/emotion';
import { colors } from '../../styles';

import PageWrapper from '../../components/PageWrapper';
import MenuContact from '../../components/MenuContact';
import InsideHeader from '../../components/InsideHeader';
import WelcomeSection from '../../components/WelcomeSection';
import ContentSection from './ContentSection';

const styles = css `
  .WelcomeSection_btn {
    height: 45px;
    padding: 0 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 700;
    font-size: 13px;
    color: #FFFFFF;
    letter-spacing: 0.12px;
    background-color: ${colors.color1};
    cursor: pointer;
    transition: all .3s ease;
    @media(min-width: 992px) {
      height: 55px;
      width: 100%;
      padding: 0 35px;
      font-size: 17px;
      letter-spacing: 0;
    }
    &:hover{
      transform: scale(1.08);
    }
  }
`;

function WarrantyInformationRequest({ page }) {
  const welcome = get(page, 'welcome_section[0]');
  return (
    <PageWrapper className={styles}>
      <PageHelmet page={page} />
      <InsideHeader
        h1={`${page.metaTags.title}`}
        background={get(page, 'page_image')}
      />
      <MenuContact />
      <WelcomeSection
        title={get(welcome, 'title')}
        lead={get(welcome, 'lead_copy')}
        image={get(welcome, 'image.contentUrl')}
        buttonLink={get(welcome, 'button_external_link')}
        buttonText={get(welcome, 'button_text')}
      />
      <ContentSection content={page} />
    </PageWrapper>
  );
}

WarrantyInformationRequest.propTypes = {
  page: PropTypes.object.isRequired,
};

export default withData(
  {
    page: 'warranty_information_request',
  },
  {
    ifMissing404: true,
  },
)(WarrantyInformationRequest);



// WEBPACK FOOTER //
// ./src/pages/WarrantyInformationRequest/index.js